import Vue from 'vue';
import Vuex from 'vuex';
import Api from "@/services/api";

// IMPORT VUEX MODULES
import companyModule from './modules/company';
import templateModule from './modules/template';
import billingModule from './modules/billing';
import messageModule from './modules/message';
import contactModule from './modules/contact';
import adminModule from './modules/admin';
import registrationModule from './modules/registration';
import chartModule from './modules/chart';
import stripeCheckout from './modules/stripeCheckout';
import tag from './modules/tag';
import broadcast from './modules/broadcast';
import recipeModule from './modules/recipe';
import cloverModule from './modules/clover';
import status from './modules/StatusIQ/status';
import stockIQModule from './modules/StockIQ/stock';
import priceIQModule from './modules/PriceIQ/price';
import smartRampModule from './modules/smartRamp';
import productRegistrationModule from './modules/SmartRamp/productRegistration';
import iqIntegrationsModule from './modules/IQIntegrations/iqIntegrations';
import messageIqSignupModule from './modules/MessageIq/signup';
import validateIqModule from './modules/ValidateIQ/validateiq';

import router from '../router';

Vue.use(Vuex);
Vue.use(require('vue-cookies'));

const store = new Vuex.Store({
    modules: {
        company: companyModule,
        template: templateModule,
        billing: billingModule,
        message: messageModule,
        contact: contactModule,
        admin: adminModule,
        registration: registrationModule,
        chart: chartModule,
        stripeCheckout: stripeCheckout,
        tag: tag,
        broadcast: broadcast,
        recipe: recipeModule,
        clover: cloverModule,
        status: status,
        stockIQ: stockIQModule,
        priceIQ: priceIQModule,
        smartRamp: smartRampModule,
        productRegistration: productRegistrationModule,
        iqIntegration: iqIntegrationsModule,
        messageIqSignup: messageIqSignupModule,
        validateIq: validateIqModule
    },
    state: {
        user: null,
        userRole: null, 
        userNotifications: false,
        setupRoute: null
    },
    mutations: {
        SET_USER(state,user){
            state.user = user;
        },
        SET_USER_ROLE(state,userRole){
            state.userRole = userRole;
        },
        SET_USER_NOTIFICATIONS(state, userNotifications){
            state.userNotifications = userNotifications;
        },
        SET_SETUP_ROUTE(state,setupRoute){
            state.setupRoute = setupRoute;
        }
    },
    actions: {
        async getUserCompany({dispatch,commit}){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            var user = await Api().get(`/Web/User/GetUserAndCompany`,config).catch(err => {
                if(err.response.status === 404){
                    let notFoundUserBody = err.response.data;
                    if(notFoundUserBody.isBadEmail){
                        Vue.prototype.$swal.fire({
                            title: "Invalid Email",
                            text: "Email Address is invalid. You must use a company email.",
                            icon: 'error',
                            allowOutsideClick: false,
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#0CC27E"
                        }).then(() => {
                            router.push('/logout');
                        });
                    }else{
                        return null;
                    }
                }else{
                    Vue.prototype.$swal.fire({
                        title: "Error",
                        text: "An error occurred while pulling your profile data. Please try again later.",
                        icon: 'error',
                        allowOutsideClick: false,
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#0CC27E"
                    }).then(() => {
                        router.push('/logout');
                    });
                }
            });

            if (user) {
                commit("SET_USER",user.data.user);
                commit("SET_USER_ROLE",user.data.userRole);
                dispatch("company/setCurrentCompany",user.data.company);
                dispatch("company/setCurrentCompanyApps",user.data.companyApps);

                commit("SET_USER_NOTIFICATIONS",user.data.user.notifications);

                return user.data;
            }
        
            return user;
        },
        async getUserCompanyApps({dispatch,commit},app){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            var user = await Api().get(`/Web/User/GetUserAndCompany`,config).catch(err => {
                if(err.response.status === 404){
                    let notFoundUserBody = err.response.data;
                    if(notFoundUserBody.isBadEmail){
                        Vue.prototype.$swal.fire({
                            title: "Invalid Email",
                            text: "Email Address is invalid. You must use a company email.",
                            icon: 'error',
                            allowOutsideClick: false,
                            confirmButtonText: "Ok",
                            confirmButtonColor: "#0CC27E"
                        }).then(() => {
                            router.push('/logout');
                        });
                    }else{
                        router.push({path: '/sr/registration', query: { app: app}});
                    }
                }else{
                    Vue.prototype.$swal.fire({
                        title: "Error",
                        text: "An error occurred while pulling your profile data. Please try again later.",
                        icon: 'error',
                        allowOutsideClick: false,
                        confirmButtonText: "Ok",
                        confirmButtonColor: "#0CC27E"
                    }).then(() => {
                        router.push('/logout');
                    });
                }
            });
            commit("SET_USER",user.data.user);
            commit("SET_USER_ROLE",user.data.userRole);
            dispatch("company/setCurrentCompany",user.data.company);
            dispatch("company/setCurrentCompanyApps",user.data.companyApps);
            return user.data;
        },
        async upgradeUserAccount({},userId){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            await Api().put(`/Web/User/SetAuthIdByUserId/${userId}`,{},config).catch(err => {
                //TODO: Show error
                console.error(err.message);
                return false;
            });
            return true;
        },
        async impersonateUser({dispatch, commit},companyId){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            let user = await Api().put(`/Web/Admin/ImpersonateUser/${companyId}`,{},config).catch(err => {
                //TODO: Show error
                console.error(err.message);
                return null;
            });
            commit("SET_USER",user.data.user);
            dispatch("company/setCurrentCompany",user.data.company);
            return user.data;
        },
        async loginAsAgencyCompany({dispatch, commit},id){
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };
            let user = await Api().put(`/Web/User/ImpersonateAgencyCustomer/${id}`,{},config)
            .catch(err => {
                console.error(err.message);
                return null;
            });
            commit("SET_USER",user.data.user);
            dispatch("company/setCurrentCompany",user.data.company);
            return user.data;
        },
        async loginAsAgencyCompany({dispatch, commit},id){
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };
            let user = await Api().put(`/Web/User/ImpersonateAgencyCustomer/${id}`,{},config)
            .catch(err => {
                console.error(err.message);
                return null;
            });
            commit("SET_USER",user.data.user);
            dispatch("company/setCurrentCompany",user.data.company);
            return user.data;
        },
        async addCompanyApp({dispatch},app){
            let authToken = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${authToken}` }
            };
            await Api().put(`Web/Company/AddCompanyApp/${app}`,{},config).catch(err => {
                return false;
            });
            dispatch("company/addCompanyApp",app);
            return true;
        },
        async getUserCompanyAppsGuard() {
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            var user = await Api().get(`/Web/User/GetUserAndCompany`,config).catch(err => {
                console.error(err.message);
            });
            return user ? user.data : false;
        },
        async getUserForTemplates({dispatch,commit}){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            const user = await Api().get(`/Web/User/GetUserAndCompany`,config).catch(err => {
                Vue.prototype.$swal.fire({
                    title: "Error",
                    text: "An error occurred while pulling your profile data. Please try again later.",
                    icon: 'error',
                    allowOutsideClick: false,
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#0CC27E"
                }).then(() => {
                    router.push('logout');
                });
            });
            commit("SET_USER",user.data.user);
            commit("SET_USER_ROLE",user.data.userRole);
            return user.data.user;
        },
        async getUserCompanyGuard(){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            var user = await Api().get(`/Web/User/GetUserAndCompany`,config).catch(err => {
                if(err.response.status === 404){
                    const notFoundUserBody = err.response.data;
                    if(notFoundUserBody.isBadEmail) {
                        return true;
                    } 

                    return false;
                }
                return true;
            });

            if(user) if(user.data) if(user.data.companyApps) this.state.company.currentCompanyApps = user.data.companyApps;

            return user.data;
        },
        async updateUserNotification({commit}, notifications){
            let token = await Vue.prototype.$auth.getTokenSilently();
            let config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            await Api().post(`/Web/User/UpdateNotificationSetting`, notifications, config).catch(err => {
                //TODO: Show error
                console.error(err.message);
                return false;
            });
            return true;
        },
        saveSetupRoute({ commit }, route) {
            commit("SET_SETUP_ROUTE",route);
        }
    },
    getters: {
        getUser: state => { return state.user },
        getUserRole: state => { return state.userRole },
        getUserNotifications: state => { return state.userNotifications }
    }
});

export default store;